import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import { LeftOutlined } from 'components/Icon'

const AppropriatenessTestNavigationUI: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div>
      <Button className='back-button' onClick={() => navigate(-1)}>
        <LeftOutlined />
      </Button>
    </div>
  )
}

export const AppropriatenessTestNavigation = AppropriatenessTestNavigationUI
